module.exports = appSettings;